import { enhancedT } from 'app-i18n';

export const translateOptionLabel = (option, labelPropertyName) =>
  option.translatableLabel ? enhancedT(option.translatableLabel) : option[labelPropertyName];
